export const pronounQuestions = [
  {
    id: 1,
    koreanQuestion:
      "새로운 마케팅 전략은 잘 받았다 고객들에 의해 ____ 효과적으로 해결했기 때문에 그들의 우려를",
    question:
      "The new marketing strategy was well received by customers because ______ effectively addressed their concerns.",
    choices: {
      A: "it",
      B: "its",
      C: "them",
      D: "they",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 그 전략에 해당하는 걸 받을 수 있는 지시대명사는 it 입니다.",
    translation:
      "새로운 마케팅 전략은 고객들에게 좋은 반응을 얻었다. 왜냐하면 그것이 효과적으로 그들의 우려를 해결했기 때문이다.",
    type: "pronoun",
  },
  {
    id: 2,
    koreanQuestion:
      "회사는 최근 도입했다 유연한 근무 정책을, 그리고 _____ (현재) 크게 향상시켰다 직원들 만족도를.",
    question:
      "The company recently introduced a flexible work policy, and ______ has significantly improved employee satisfaction.",
    choices: {
      A: "they",
      B: "their",
      C: "it",
      D: "them",
    },
    correctAnswer: "C",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 근무 정책에 해당하는 걸 받을 수 있는 지시대명사는 it 입니다.",
    translation:
      "회사는 최근 유연한 근무 정책을 도입했으며, 그것이 직원들의 만족도를 크게 향상시켰다.",
    type: "pronoun",
  },
  {
    id: 3,
    koreanQuestion:
      "개정된 회사 정책은 목표로 한다 향상시키는 것을 생산성을 보장하면서 그... ____ 유지되도록 공정하게 모든 직원에게",
    question:
      "The revised company policy aims to enhance productivity while ensuring that ______ remains fair for all employees.",
    choices: {
      A: "it",
      B: "they",
      C: "them",
      D: "its",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 개정된 회사 정책에 해당하는 걸 받을 수 있는 지시대명사는 it 입니다.",
    translation:
      "개정된 회사 정책은 생산성을 높이는 동시에 그것이 모든 직원에게 공정하게 유지되도록 한다.",
    type: "pronoun",
  },
  {
    id: 5,
    koreanQuestion:
      "회사는 개정했다 ____  정책들을 준수하기 위해 새로운 정부 규정들을",
    question:
      "The company revised ______ policies to comply with new government regulations.",
    choices: {
      A: "its",
      B: "it",
      C: "them",
      D: "their",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 회사의 소유격에 해당하는 걸 받을 수 있는 지시대명사는 its 입니다.",
    translation:
      "회사는 새로운 정부 규정을 준수하기 위해 그 회사의 정책을 개정했다.",
    type: "pronoun",
  },
  {
    id: 6,
    koreanQuestion:
      "고객들은 만족했다 새로운 반품 정책에 대해  _______ 허용했기 때문에 그들이 받는 것을 전액 환불을",
    question:
      "Customers were happy with the new return policy because ______ allowed them to receive full refunds.",
    choices: {
      A: "it",
      B: "its",
      C: "them",
      D: "their",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 새로운 반품 정책에 해당하는 걸 받을 수 있는 지시대명사는 it 입니다.",
    translation:
      "고객들은 새로운 반품 정책이 전액 환불을 받을 수 있도록 해주어 만족했다.",
    type: "pronoun",
  },
  {
    id: 7,
    koreanQuestion:
      "위원회는 검토했다 여러 제안서를 그리고 선택했다 ____ 그.. 가장 부합하는 회사의 목표에 ",
    question:
      "The committee reviewed several proposals and selected ______ that best aligned with the company's goals.",
    choices: {
      A: "it",
      B: "its",
      C: "one",
      D: "them",
    },
    correctAnswer: "C",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 여러 제안서 중 하나를 선택하는 상황이므로 'one'이 적절합니다. 'it'은 단수 대명사로 복수 선행사와 맞지 않고, 'its'는 소유격이며, 'them'은 복수 대명사로 하나를 선택하는 상황과 맞지 않습니다.",
    translation:
      "위원회는 여러 제안서를 검토한 후 회사의 목표에 가장 부합하는 하나를 선택했다.",
    type: "pronoun",
  },

  {
    id: 8,
    koreanQuestion:
      "회의는 생산적이었다 모두가 기여했기 때문에 그리고 표현했기 때문에 ___ 의견들을 자유롭게",
    question:
      "The meeting was productive because everyone contributed and expressed ______ opinions freely.",
    choices: {
      A: "it",
      B: "them",
      C: "their",
      D: "themselves",
    },
    correctAnswer: "C",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 everyone의 소유격이 필요하므로 'their'가 적절합니다. 'it'은 단수 대명사로 소유격이 아니고, 'them'은 목적격 대명사이며, 'themselves'는 재귀대명사로 소유격으로 사용할 수 없습니다.",
    translation:
      "회의는 모두가 기여하고 자신들의 의견을 자유롭게 표현했기 때문에 생산적이었다.",
    type: "pronoun",
  },
  {
    id: 9,
    koreanQuestion:
      "만약 고객들이 가진다면 어떤 질문들을, 보내주세요 ___  우리의 고객지원팀으로",
    question:
      "If customers have any questions, please direct ______ to our customer support team.",
    choices: {
      A: "it",
      B: "them",
      C: "their",
      D: "they",
    },
    correctAnswer: "B",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 questions(질문들)의 목적격이 필요하므로 'them'이 적절합니다. 'it'은 단수 대명사로 복수 선행사와 맞지 않고, 'their'는 소유격이며, 'they'는 주격 대명사로 목적어 위치에 사용할 수 없습니다.",
    translation:
      "고객에게 질문이 있으면, 그것들을 고객 지원팀으로 보내 주세요.",
    type: "pronoun",
  },

  {
    id: 10,
    koreanQuestion:
      "재무 분석가는 검토했다 회사의 지출들을 그리고 분류 했다 ______ 부서별로.",
    question:
      "The financial analyst reviewed the company's expenses and categorized ______ by department.",
    choices: {
      A: "it",
      B: "their",
      C: "them",
      D: "they",
    },
    correctAnswer: "C",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 expenses(지출들)의 목적격이 필요하므로 'them'이 적절합니다. 'it'은 단수 대명사로 복수 선행사와 맞지 않고, 'their'는 소유격이며, 'they'는 주격 대명사로 목적어 위치에 사용할 수 없습니다.",
    translation:
      "재무 분석가는 회사의 지출을 검토하고 그것들을 부서별로 분류했다.",
    type: "pronoun",
  },
  {
    id: 11,
    koreanQuestion:
      "모든 직원들은 반드시 읽어야 한다 그리고 사인해야 한다 계약서에 제출하기전에  ______ 인사부에 ",
    question:
      "All employees must read and sign the agreement before submitting ______ to the HR department.",
    choices: {
      A: "it",
      B: "its",
      C: "them",
      D: "their",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 agreement(계약서)의 목적격이 필요하므로 'it'이 적절합니다. 'its'는 소유격 대명사이고, 'them'은 복수 목적격으로 단수 선행사와 맞지 않으며, 'their'는 소유격 대명사로 목적어 위치에 사용할 수 없습니다.",
    translation:
      "모든 직원들은 계약서를 읽고 서명한 후, 그것을 인사부에 제출해야 한다.",
    type: "pronoun",
  },
  {
    id: 12,
    koreanQuestion:
      "임원들은 논의했다 회사의 장기 목표들을 그리고 어떻게 달성할지 _____  효율적으로.",
    question:
      "The executives discussed the company's long-term goals and how to achieve ______ efficiently.",
    choices: {
      A: "it",
      B: "them",
      C: "their",
      D: "they",
    },
    correctAnswer: "B",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 long-term goals(장기 목표들)의 목적격이 필요하므로 'them'이 적절합니다. 'it'은 단수 대명사로 복수 선행사와 맞지 않고, 'their'는 소유격이며, 'they'는 주격 대명사로 목적어 위치에 사용할 수 없습니다.",
    translation:
      "임원들은 회사의 장기 목표와 그것들을 효율적으로 달성하는 방법에 대해 논의했다.",
    type: "pronoun",
  },
  {
    id: 13,
    koreanQuestion:
      "몇몇 후보자들이 인터뷰 되었다 그 직책을 위해, 그러나 두 명만 _____  선정되었다. 최종 라운드에 ",
    question:
      "Several candidates were interviewed for the position, but only two of ______ were selected for the final round.",
    choices: {
      A: "they",
      B: "them",
      C: "their",
      D: "it",
    },
    correctAnswer: "B",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 candidates(후보자들)의 목적격이 필요하므로 'them'이 적절합니다. 'they'는 주격 대명사로 전치사 of 뒤에 사용할 수 없고, 'their'는 소유격이며, 'it'은 단수 대명사로 복수 선행사와 맞지 않습니다.",
    translation:
      "몇몇 후보자들이 면접을 보았으나, 그들 중 두 명만 최종 라운드에 선정되었다.",
    type: "pronoun",
  },
  {
    id: 14,
    koreanQuestion:
      "새로운 지침 요구한다 모든 직원들에게 완료하도록 안전 교육을 ____ 첫날 전에 근무에서의 .",
    question:
      "The new guidelines require all employees to complete safety training before ______ first day at work.",
    choices: {
      A: "they",
      B: "them",
      C: "their",
      D: "it",
    },
    correctAnswer: "C",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 all employees(모든 직원들)의 소유격이 필요하므로 'their'가 적절합니다. 'they'는 주격 대명사로 소유격 자리에 사용할 수 없고, 'them'은 목적격 대명사이며, 'it'은 단수 대명사로 복수 선행사와 맞지 않습니다.",
    translation:
      "새로운 지침에 따라 모든 직원들은 근무 첫날 전에 안전 교육을 완료해야 한다.",
    type: "pronoun",
  },
  {
    id: 15,
    koreanQuestion:
      "회사는 (현재) 도입했다 새로운 일정 관리 시스템을 증가하기 위해 효율성을, 그리고 직원들은 조정해야 한다 ____ 근무시간을 이에 따라.",
    question:
      "The company has implemented a new scheduling system to increase efficiency, and employees must adjust ______ work hours accordingly.",
    choices: {
      A: "their",
      B: "them",
      C: "they",
      D: "it",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 employees(직원들)의 소유격이 필요하므로 'their'가 적절합니다. ",
    translation:
      "회사는 효율성을 높이기 위해 새로운 일정 관리 시스템을 도입했으며, 직원들은 이에 따라 그들의 근무 시간을 조정해야 한다.",
    type: "pronoun",
  },
  {
    id: 16,
    koreanQuestion:
      "프로젝트 매니저 그리고 마케팅 디렉터는 가진다 다른 접근방식들을, 그러나 _____ 둘다 동의한다 그... 고객 피드백이 필수적이라고 성공에.",
    question:
      "The project manager and the marketing director have different approaches, but ______ both agree that customer feedback is essential for success.",
    choices: {
      A: "they",
      B: "them",
      C: "it",
      D: "their",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'The project manager and the marketing director'(프로젝트 매니저와 마케팅 디렉터)의 주격이 필요하므로 'they'가 적절합니다. ",
    translation:
      "프로젝트 매니저와 마케팅 디렉터는 접근 방식이 다르지만, 그들은 모두 고객 피드백이 성공에 필수적이라고 동의한다.",
    type: "pronoun",
  },
  {
    id: 17,
    koreanQuestion:
      "고객은 만족하지 못했다 응답에, 그래서 그녀는 결정했다 해결하기로 그 문제를 ____ ",
    question:
      "The customer was not satisfied with the response, so she decided to handle the issue ______.",
    choices: {
      A: "herself",
      B: "her",
      C: "she",
      D: "hers",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'she'(그녀)가 스스로 문제를 해결한다는 의미로 재귀대명사 'herself'가 적절합니다. ",
    translation:
      "고객은 응답에 만족하지 못해 스스로 문제를 해결하기로 결정했다.",
    type: "pronoun",
  },
  {
    id: 18,
    koreanQuestion:
      "직원들은 분배했다 업무량을 ____ 사이에서 완료하기 위해 프로젝트를 제시간에.",
    question:
      "The employees divided the workload among ______ to complete the project on time.",
    choices: {
      A: "themselves",
      B: "them",
      C: "their",
      D: "they",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'employees'(직원들)가 서로 간에 업무를 나누는 의미로 재귀대명사 'themselves'가 적절합니다.",
    translation:
      "직원들은 프로젝트를 제시간에 완료하기 위해 그들끼리 업무량을 분배했다.",
    type: "pronoun",
  },
  {
    id: 19,
    koreanQuestion:
      "안전상의 이유로 모든 방문객은 반드시 확인해야 한다 _____ 프론트 데스크에서 들어가기전에 건물에  ",
    question:
      "For safety reasons, all visitors must identify ______ at the front desk before entering the building.",
    choices: {
      A: "themselves",
      B: "them",
      C: "their",
      D: "they",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'visitors'(방문객들)가 자신의 신원을 확인하는 의미로 재귀대명사 'themselves'가 적절합니다.",
    translation:
      "안전상의 이유로 모든 방문객은 건물에 들어가기 전에 프론트 데스크에서 자신의 신원을 확인해야 한다.",
    type: "pronoun",
  },
  {
    id: 20,
    koreanQuestion: "매니저들은 축하했다 _____  성공적 출시에 대해 새로운 제품",
    question:
      "The managers congratulated ______ on the successful launch of the new product.",
    choices: {
      A: "themselves",
      B: "them",
      C: "their",
      D: "they",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'managers'(매니저들)가 자신들을 축하하는 의미로 재귀대명사 'themselves'가 적절합니다.",
    translation: "매니저들은 신제품 출시의 성공을 기념하며 서로를 축하했다.",
    type: "pronoun",
  },
  {
    id: 21,
    koreanQuestion:
      "온라인 강의가 자기 주도형이었기 때문에, 학생들은 동기부여해야 했다 ____ 완료하기위해 과제를 제때 ",
    question:
      "Since the online course was self-paced, students had to motivate ______ to complete the assignments on time.",
    choices: {
      A: "them",
      B: "their",
      C: "themselves",
      D: "they",
    },
    correctAnswer: "C",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'students'(학생들)가 자신들에게 동기를 부여하는 의미로 재귀대명사 'themselves'가 적절합니다.",
    translation:
      "온라인 강의가 자기 주도형이었기 때문에, 학생들은 과제를 제때 완료하도록 스스로 동기부여를 해야 했다.",
    type: "pronoun",
  },
  {
    id: 22,
    koreanQuestion:
      "그는 받지 않았다 공식적 교육을 그러나 배울 수 있었다 ____  어떻게 코딩을 하는지.",
    question:
      "He didn't take any formal training but managed to teach ______ how to code.",
    choices: {
      A: "him",
      B: "himself",
      C: "his",
      D: "he",
    },
    correctAnswer: "B",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'he'(그)가 자신을 가르치는 의미로 재귀대명사 'himself'가 적절합니다.",
    translation: "그는 공식적인 교육을 받지 않았지만 스스로 코딩을 배웠다.",
    type: "pronoun",
  },

  {
    id: 23,
    koreanQuestion:
      "최종버전은 계약서 ______ , 그리고 고객은 (현재) 이미 서명했다 계약서를.",
    question:
      "The final version of the contract is ______, and the client has already signed it.",
    choices: {
      A: "ours",
      B: "our",
      C: "we",
      D: "us",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'contract'(계약서)가 '우리의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'ours'가 적절합니다.",
    translation: "계약서의 최종 버전은 우리의 것이며, 고객은 이미 서명했다.",
    type: "pronoun",
  },
  {
    id: 25,
    koreanQuestion:
      "이 재무 보고서는 아니다 ___, 그 재무보고서는 속해 있다 다른 부서에",
    question:
      "This financial report is not ______, it belongs to another department.",
    choices: {
      A: "their",
      B: "theirs",
      C: "they",
      D: "them",
    },
    correctAnswer: "B",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'financial report'(재무 보고서)가 '그들의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'theirs'가 적절합니다.",
    translation: "이 재무 보고서는 그들의 것이 아니며, 다른 부서에 속해 있다.",
    type: "pronoun",
  },
  {
    id: 26,
    koreanQuestion:
      "그 노트북은 이 보관실 안에 있는 ______, 한 노트북은 다른 방 안에 있는 속해있다 IT부서에 ",
    question:
      "The laptops in this storage room are ______, while the ones in the other room belong to the IT department.",
    choices: {
      A: "us",
      B: "ours",
      C: "our",
      D: "we",
    },
    correctAnswer: "B",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'laptops'(노트북)가 '우리의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'ours'가 적절합니다.",
    translation:
      "이 보관실에 있는 노트북은 우리의 것이며, 다른 방에 있는 것은 IT 부서에 속해 있다.",
    type: "pronoun",
  },
  {
    id: 27,
    koreanQuestion: "이 파일은 아니다 ____ , 그 파일은 속해있다 마케팅 부서에.",
    question:
      "This file is not ______, it belongs to the marketing department.",
    choices: {
      A: "my",
      B: "mine",
      C: "me",
      D: "myself",
    },
    correctAnswer: "B",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'file'(파일)이 '내 것'이라는 소유 관계를 나타내기 위해 소유대명사 'mine'이 적절합니다.",
    translation: "이 파일은 내 것이 아니며, 마케팅 부서에 속해 있다.",
    type: "pronoun",
  },
  {
    id: 28,
    koreanQuestion:
      "확인해 주세요 그.. 예산 보고서가 그.. 당신이 제출했던 ____ 그리고 아닌지 이전 버전이",
    question:
      "Please ensure that the budget report you submitted is ______ and not an older version.",
    choices: {
      A: "yours",
      B: "your",
      C: "you",
      D: "yourself",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'budget report'(예산 보고서)가 '당신의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'yours'가 적절합니다.",
    translation:
      "제출한 예산 보고서가 귀하의 것이며, 이전 버전이 아닌지 확인해 주세요.",
    type: "pronoun",
  },
  {
    id: 29,
    koreanQuestion:
      "노트북은 책상위에 있던 ______ , 하지만 노트북은 회의실 안에 있던 속해있다 사라에게 ",
    question:
      "The laptop on the desk is ______, but the one in the meeting room belongs to Sarah.",
    choices: {
      A: "ours",
      B: "our",
      C: "we",
      D: "us",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'laptop'(노트북)이 '우리의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'ours'가 적절합니다.",
    translation:
      "책상 위의 노트북은 우리의 것이지만, 회의실에 있는 것은 사라의 것입니다.",
    type: "pronoun",
  },
  {
    id: 30,
    koreanQuestion:
      "제 생각엔  이 발표 폴더가 ______ , 하지만 나는 확실하진 않아요 ",
    question: "I think this presentation folder is ______, but I am not sure.",
    choices: {
      A: "hers",
      B: "her",
      C: "she",
      D: "herself",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'presentation folder'(발표 폴더)가 '그녀의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'hers'가 적절합니다.",
    translation:
      "이 발표 자료 폴더가 그녀의 것인 것 같은데, 확실하지 않습니다.",
    type: "pronoun",
  },
  {
    id: 31,
    koreanQuestion:
      "제임스는 두었다 그의 재킷을 의자에, 하지만 마이클은 실수로 가져갔다 제임스의 재킷을. 생각하며 제임스의 재킷이 _______ ",
    question:
      "James left his jacket on the chair, but Michael mistakenly took it, thinking it was ______.",
    choices: {
      A: "his",
      B: "him",
      C: "he",
      D: "himself",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'jacket'(재킷)이 '그의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'his'가 적절합니다.",
    translation:
      "제임스는 재킷을 의자 위에 두고 갔지만, 마이클은 그것이 그의 것인 줄 알고 실수로 가져갔다.",
    type: "pronoun",
  },
  {
    id: 32,
    koreanQuestion:
      "회의 후, 데이비드는 깨달았다 그... 노트북이 책상 위에 있던 ___ 아니다 , 하지만 속해있다 다른 직원에게 ",
    question:
      "After the meeting, David realized that the laptop on the desk was not ______, but belonged to another employee.",
    choices: {
      A: "his",
      B: "him",
      C: "he",
      D: "himself",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'laptop'(노트북)이 '그의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'his'가 적절합니다.",
    translation:
      "회의 후, 데이비드는 책상 위에 있는 노트북이 그의 것이 아니라 다른 직원의 것임을 깨달았다.",
    type: "pronoun",
  },
  {
    id: 33,
    koreanQuestion:
      "사라는 실수로 가져갔다 엠마의 휴대전화를, 생각하며 엠마의 휴대전화가 ____ ",
    question: "Sarah accidentally took Emma's phone, thinking it was ______.",
    choices: {
      A: "her",
      B: "hers",
      C: "she",
      D: "herself",
    },
    correctAnswer: "B",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'phone'(휴대전화)이 '그녀의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'hers'가 적절합니다.",
    translation:
      "사라는 그것이 그녀의 것인 줄 알고 실수로 엠마의 휴대전화를 가져갔다.",
    type: "pronoun",
  },
  {
    id: 34,
    koreanQuestion:
      "회사는 제공했다 새 노트북을 영업 및 마케팅 팀을 위해 , 그러나 IT 부서는 결정했다 계속 사용하기로 _______ ",
    question:
      "The company provided new laptops for the sales and marketing teams, but the IT department decided to keep using ______.",
    choices: {
      A: "their",
      B: "theirs",
      C: "them",
      D: "they",
    },
    correctAnswer: "B",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'financial report'(재무 보고서)가 '그들의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'theirs'가 적절합니다.",
    translation:
      "회사는 영업 및 마케팅 팀에 새로운 노트북을 제공했지만, IT 부서는 그들의 것을 계속 사용하기로 결정했다.",
    type: "pronoun",
  },
  {
    id: 35,
    koreanQuestion:
      "브라이언이 실수로 저장했다 그의 문서를 잘못된 폴더에, 그러나 다행히,  나는 찼았다 ______ 브라이언 문서가 삭제되기 전에.",
    question:
      "Brian accidentally saved his document in the wrong folder, but fortunately, I found ______ before it was deleted.",
    choices: {
      A: "his",
      B: "he",
      C: "him",
      D: "himself",
    },
    correctAnswer: "A",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'document'(문서)가 '그의 것'이라는 소유 관계를 나타내기 위해 소유대명사 'his'가 적절합니다.",
    translation:
      "브라이언이 실수로 그의 문서를 잘못된 폴더에 저장했지만, 다행히 나는 그의 것을 삭제되기 전에 찾았다.",
    type: "pronoun",
  },
  {
    id: 36,
    koreanQuestion:
      "직원들은 그.. 일하는 재택으로 일하는 경향이 있다 더 오랜 시간 _____ 보다 사무실 안에서 ",
    question:
      "Employees who work remotely tend to work longer hours than ______ in the office.",
    choices: {
      A: "that",
      B: "them",
      C: "those",
      D: "these",
    },
    correctAnswer: "C",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'employees'(직원들)가 '사무실에 있는 직원들'이라는 의미를 나타내기 위해 복수 지시대명사 'those'가 적절합니다.",
    translation:
      "원격 근무하는 직원들은 사무실에서 일하는 직원들보다 더 긴 시간을 일하는 경향이 있다.",
    type: "pronoun",
  },
  {
    id: 37,
    koreanQuestion: "그 회사의 가치들은 다르다 _____ 과 그 회사의 경쟁사들",
    question:
      "The company's values are different from ______ of its competitors.",
    choices: {
      A: "it",
      B: "that",
      C: "those",
      D: "these",
    },
    correctAnswer: "C",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'values'(가치들)가 '경쟁사들의 가치들'이라는 소유 관계를 나타내기 위해 복수 지시대명사 'those'가 적절합니다.",
    translation: "그 회사의 가치들은 경쟁사들의 것들과 다르다.",
    type: "pronoun",
  },
  {
    id: 38,
    koreanQuestion:
      "최신 스마트폰들은 가진다 더 긴 배터리 수명을  _____ 보다 그..출시된 작년에",
    question:
      "The latest smartphones have better battery life than ______ released last year.",
    choices: {
      A: "that",
      B: "them",
      C: "those",
      D: "this",
    },
    correctAnswer: "C",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'smartphones'(스마트폰들)가 '작년에 출시된 스마트폰들'이라는 의미를 나타내기 위해 복수 지시대명사 'those'가 적절합니다.",
    translation:
      "최신 스마트폰들은 작년에 출시된 것들보다 더 긴 배터리 수명을 가지고 있다.",
    type: "pronoun",
  },
  {
    id: 39,
    koreanQuestion:
      "채용 매니저는  연락할 것이다 _____  그... 제출한 그들의 지원서를 마감 기한 전에",
    question:
      "The hiring manager will contact ______ who submitted their applications before the deadline.",
    choices: {
      A: "that",
      B: "these",
      C: "those",
      D: "them",
    },
    correctAnswer: "C",
    explanation:
      "항상 이런 지시대명사가 나오면 이 지시대명사를 '그것', '이것'이라고 해석하기보다 실제 지칭하는 것을 넣어서 해석해보세요. 여기서 'people'(사람들)이 '마감 기한 전에 지원서를 제출한 사람들'이라는 의미를 나타내기 위해 복수 지시대명사 'those'가 적절합니다.",
    translation:
      "채용 매니저는 마감 기한 전에 지원서를 제출한 사람들에게 연락할 것입니다.",
    type: "pronoun",
  },
];
